/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const pureWaveSettingModelSchema = z.object({
    "trackFrequency": z.number().int().describe("Частота трека"),
"podcastFrequency": z.number().int().describe("Частота подкаста")
    })